import { useSyncExternalStore } from 'react'

/** Screens big enough to hold one section per screen: magnetic paging, the night fade. */
export const pagedViewportQuery = '(min-width: 901px) and (min-height: 620px)'

const subscribe = (onChange: () => void) => {
  const query = window.matchMedia?.(pagedViewportQuery)
  query?.addEventListener('change', onChange)
  return () => query?.removeEventListener('change', onChange)
}

/** False on the server, while hydrating and on smaller screens. */
export const usePagedViewport = () =>
  useSyncExternalStore(subscribe, () => window.matchMedia?.(pagedViewportQuery).matches ?? false, () => false)
